import { Component } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../../auth/auth.interceptor';
import {Router, RouterLink} from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {mostrarToast} from "../../utils/utilities";
import {ServiceNotificationService} from "../../services/service-notification.service";
import {NotificationsComponent} from "../../notifications/notifications.component";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink, NotificationsComponent],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  }]
})
export class LoginComponent {
  constructor(
    private authService: AuthService,
    private router: Router,
    private serviceNotificationService: ServiceNotificationService
  ) {}

  loginInput = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
  });

  loginValidation() {
    if (this.loginInput.valid) {
      const { username, password } = this.loginInput.value;
      this.authService.login(username, password).subscribe({
        next: response => {
          this.router.navigate(['/dashboardmkt']);
          mostrarToast('Bienvenido Inicio de sesión exitoso', true , this.serviceNotificationService );
        },
        error: error => {
          mostrarToast(`Error ${error}`, false , this.serviceNotificationService );

          console.error('Login failed', error);
        }
      });
    } else {
      mostrarToast('Ingrese las credenciales', false , this.serviceNotificationService );

      console.log("Invalid");
    }
  }
}
